<template>
  <div>
    <v-tabs v-model="currentView" color="white" :slider-color="$vuetify.theme.primary">
      <v-tab
        v-if="broadcastPermission.create_broadcast"
        :key="'broadcast'"
        :to="{ path: 'aira', name: 'aira-broadcast' }"
        ripple
        :href="'#broadcast'"
      >
        {{ $t('Broadcast') }}
      </v-tab>
      <v-tab
        v-if="broadcastPermission.approve_broadcast"
        :key="'approval-broadcast'"
        :to="{ name: 'approval-broadcast' }"
        ripple
        :href="'#approval-broadcast'"
      >
        {{ $t('approval_broadcast') }}
      </v-tab>
    </v-tabs>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentView: 'broadcast'
    }
  },
  computed: {
    broadcastPermission() {
      return this.$store.state.privilege && this.$store.state.privilege.broadcast_permission
    }
  },
  mounted() {
    if (
      this.broadcastPermission &&
      !this.broadcastPermission.create_broadcast &&
      this.broadcastPermission.approve_broadcast
    ) {
      this.$router.push({ name: 'approval-broadcast' })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/Aira/Broadcast/BroadcastMenu.vue